import { memo } from 'react';

export const StripeNotSupported = memo(() => (
  <div>
    Stripe not supported in current browser. Please try on desktop.
  </div>
));

export default StripeNotSupported;